<template>
    <dashboard-layout tit="근무자 현황" fullHeight>
        <template slot="contents">

            <!-- 검색필터 -->
            <worker-filter class="mb-12 mb-lg-20" style="flex: 0 0 auto" />

            <div class="mb-12 mb-lg-20" style="flex: 0 0 auto">
                <v-row align="center">
                    <v-col>
                        <v-row align="center" class="row--small">
                            <v-col cols="auto">
                                <v-checkbox v-model="isSelect" @change="selectAll" hide-details label="전체" class="v-input--checkbox--lg" />
                            </v-col>
                            <v-col cols="auto">
                                <texting-dialog v-bind="textingProps">
                                    <template #activator="{ attrs, on }">
                                        <v-btn v-bind="attrs" v-on="on" outlined color="primary" small>
                                            <span>계약서 문자 발송</span>
                                        </v-btn>
                                    </template>
                                </texting-dialog>
                            </v-col>
                            <!-- <v-col cols="auto">
                                <v-btn outlined color="primary" small>계약서 문자 발송</v-btn>
                            </v-col> -->
                        </v-row>
                    </v-col>
                    <v-col cols="auto">
                        <v-select hide-details outlined class="w-100px"
                            v-model="limit"
                            :items="[10, 20]"
                         />
                    </v-col>
                </v-row>
            </div>

            <template v-if="contracts.length">
                <div class="mt-n20">

                    <!-- 근무자 -->
                    <worker-item 
                    v-for="contract in contracts" :key="contract?._id" :value="contract" :recruitment="contract.application.recruitment" 
                    :places="places" :selectedApplicants="selectedApplicants" @deleteContract="deleteContract" @select="toggle"/>

                </div>
                <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" class="my-16" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
            </template>


            <template v-else>
                <v-layout column justify-center align-center class="w-100 h-100 grey-f7 rounded-lg pa-20">
                    <p class="page-text--lg line-height-15 text-center mb-12 mb-lg-32">
                        안녕하세요, 담당자님. <br />
                        근무자가 없습니다.
                    </p>
                </v-layout>
            </template>

            <v-fade-transition>
                <v-overlay v-show="loading" color="white">
                    <v-progress-circular size="100" width="5" color="primary" indeterminate />
                </v-overlay>
            </v-fade-transition>
        </template>
    </dashboard-layout>
</template>

<script>
import api from '@/api';
import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";
import WorkerFilter from "@/components/dashboard/company/worker/worker-filter.vue";
import WorkerItem from "@/components/dashboard/company/worker/worker-item.vue";
import TextingDialog from "@/components/dashboard/company/texting/texting-dialog.vue";

export default {
    components: {
        DashboardLayout,
        WorkerFilter,
        WorkerItem,
        TextingDialog
    },
    data: () => ({
        limit: 10,
        summary: { totalCount: 0 },
        loading: false,
        isSelect: false,

        contracts: [],
        places: [],
        selectedApplicants: []
    }),
    mounted() {
        this.init();
        this.placeList();
    },
    methods: {
        init() {
            const { ...query } = this.$route.query;
            if (query.page) delete query.page;
            if (query.page != this.$route.query.page) {
                this.$router.replace({ query });
            }
            this.$nextTick(this.search);
        },
        async search() {
            this.loading = true;
            try{
                let { skip, limit, params } = this;
                const { summary, contracts } = await api.v1.company.employment.contracts.gets({
                    headers:{ skip, limit },
                    params,
                });
                this.summary = summary;
                this.contracts = contracts;
                this.loading = false;
            } catch(e){
                console.error(e)
            }
        },
        async deleteContract(_contract) {
            if(confirm('삭제하시겠습니까?')){
                await api.v1.company.employment.contracts.delete({_id: _contract});
                this.search();

                alert('삭제되었습니다.');
            }
        },
        async placeList() {
            try{
                let { places } = await api.v1.company.employment.places.gets({});
                this.places = places;
                
            } catch(e) {
                console.error(e);
            }
        },
        toggle(item){
            const isInValue = this.selectedApplicants.some(({ _id }) => _id == item._id);
            let items = isInValue ? this.selectedApplicants.filter(({ _id }) => _id != item._id) : [...this.selectedApplicants, item];
            this.selectedApplicants = items;
        },
        selectAll(){
            if(this.selectedApplicants.length !== this.contracts.length){
                this.selectedApplicants = [];
                for (let contract of this.contracts){
                    this.selectedApplicants.push(contract);
                }
            } else{
                this.selectedApplicants = [];
            }
        },
        addresseeFilter(){
            return this.selectedApplicants.filter(
                (contract, index, arr) =>
                { return index === arr.findIndex(el => el._application === contract._application)}
            );
        }
    },
    computed: {
        items() {
            return this.contracts.map((item, index) => ({...item, index: this.summary.totalCount - (this.page -1) * this.limit - index}));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;
            return { ...query };
        },
        textingProps() {
            const contracts = this.addresseeFilter();
            let addressees = {
                value: [],
                applications: []
            }
            contracts.map((contract)=>
                {addressees.value.push(contract.application); 
                 addressees.applications.push(contract.application);
                });
            return addressees;
            // return {
            //     value: this.selectedApplicants,
            //     applications: this.selectedApplicants,

            // };
        },
        },
    watch: {
        params() {
            this.isSelect= false;
            this.search();
        },
        limit() {
            this.init();
        },
        selectedApplicants(){
            this.isSelect = this.selectedApplicants.length === this.contracts.length ? true : false;
        }
    },
};
</script>

<style></style>
